import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { usePermissions } from '../../hooks/usePermissions';
import { ModulePermissions, UserModulePermissions } from '../../types/user';
import LoadingScreen from '../common/LoadingScreen';
import NoAccess from '../common/NoAccess';

interface ProtectedRouteProps {
  allowedRoles?: string[];
  requiredModule?: keyof UserModulePermissions;
  requiredPermission?: ModulePermissions;
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  allowedRoles, 
  requiredModule, 
  requiredPermission = 'access',
  children 
}) => {
  const { user, loading } = useAuth();
  const { hasPermission } = usePermissions();

  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  
  // Szervezet ellenőrzés (kivéve super_admin)
  if (!user.organizationId && user.role !== 'super_admin') {
    return <NoAccess />;
  }
  
  // Szerepkör alapú ellenőrzés
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={user.role === 'customer' ? '/customer-portal' : '/'} replace />;
  }
  
  // Modul alapú jogosultság ellenőrzés
  if (requiredModule && !hasPermission(requiredModule, requiredPermission)) {
    return <Navigate to={user.role === 'customer' ? '/customer-portal' : '/'} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute; 